document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target
        const animation = element.getAttribute('data-animate')
        const delay = element.getAttribute('data-animate-delay') || 0

        setTimeout(() => {
          element.classList.add(`animate-${animation}`)
          element.classList.remove('opacity-0')
        }, delay)

        observer.unobserve(element)
      }
    })
  }, observerOptions)

  // アニメーション対象の要素を監視
  document.querySelectorAll('[data-animate]').forEach(element => {
    observer.observe(element)
  })
})
